import { get } from "lodash";

/**
 * Số tiền hiện trên băng-rôn màn kết quả giao dịch tiền gửi (#56134).
 *
 * Trước đây component đọc `state.dataConfirm.savingsDetail.savingsAmountDisplay`. Chuỗi
 * `savingsDetail` KHÔNG tồn tại trong bất kỳ response nào — grep toàn repo chỉ ra đúng một chỗ
 * dùng là chính dòng đó. Nên băng-rôn luôn trống với mọi giao dịch tiền gửi, không riêng ca rút
 * gốc từng phần mà tester bắt được.
 *
 * Nay lấy `totalAmountDisplay` của `getTransactionDetail` — cùng nguồn với dòng "Tổng tiền nhận"
 * ngay bên dưới, và khớp bản thiết kế (số trên băng-rôn bằng tổng tiền nhận). Backend đã định dạng
 * sẵn kèm đơn vị tiền tệ nên không tính lại ở web.
 *
 * Tách khỏi component để test chạm được vào ĐÚNG phép chọn mà component dùng, thay vì chép lại.
 */
export const SAVINGS_BANNER_AMOUNT_PATH =
  "body.transactionDetail.savingsTransaction.totalAmountDisplay";

export const pickSavingsBannerAmount = (detailData: unknown): string => {
  const amount = get(detailData, SAVINGS_BANNER_AMOUNT_PATH, "");
  return typeof amount === "string" ? amount.trim() : "";
};
